import React, { PropsWithChildren, FC } from 'react';

import styled from 'styled-components';

// theme
import aampeTheme from '../../../../../constants/aampeTheme';

const VariationPlaceholder: FC<PropsWithChildren<unknown>> = () => {
    return (
        <Container>
            <HeaderText>
                Start by selecting the text that you want to vary, like this:
            </HeaderText>
            <Image
                src={
                    'https://storage.googleapis.com/assets.aampe.com/app_images/empty_state_placeholders/select_some_text_animated.gif'
                }
                alt={'Placeholder'}
            />
        </Container>
    );
};

const Container = styled.div({
    width: '400px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: aampeTheme.spacing4(3),
});
const HeaderText = styled.p(() => ({
    marginTop: aampeTheme.spacing(2),
    fontSize: '14px',
    textAlign: 'center',
    color: aampeTheme.colors.textAccessibleWG01,
}));

const Image = styled.img(() => ({
    width: '400px',
    height: '200px',
}));

export default VariationPlaceholder;
